<template>
  <div class="box">
    <OperationBoxComponent :actions="actions" :filters="filters" />
    <AreaListComponent :page-data="pageData" :handle-remove="remove" v-if="pageData.items" @onItemEdit="editArea" @onPageChanged="onPageChanged" />
    <el-dialog title="编辑片区" :visible.sync="showEditDialog" width="30%" :close-on-click-modal="false">
      <el-form :model="formData">
        <el-form-item label="片区名称" label-width="120px" :rules="[{ required: true, message: '名称不能为空'}]">
          <el-input v-model="formData.name" maxlength="30" placeholder="不超过30个字" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import {MilkRequestUtil} from '../../../utils/MilkRequestUtil'
import AreaListComponent from '../../../components/area/AreaListComponent'
export default {
  name: 'MilkAreaListPage',
  components: { AreaListComponent, OperationBoxComponent },
  data () {
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateAreaList },
        { title: '添加片区', type: 'button', theme: 'success', action: this.editArea }
      ],
      filters: [{
        searchValue: '',
        type: 'name',
        title: '片区名称',
        options: [{
          title: '片区名称',
          value: 'name'
        }],
        action: this.onFilterChange
      }],
      pageData: {items: []},
      formData: {id: 0, name: ''},
      showEditDialog: false,
      queryParam: {
        page: 1,
        pageSize: 25
      }
    }
  },
  mounted () {
    this.updateAreaList()
  },
  methods: {
    editArea (data) {
      this.showEditDialog = true
      if (data.id) {
        this.formData = JSON.parse(JSON.stringify(data))
      } else {
        this.formData = {id: 0, title: ''}
      }
    },
    save () {
      let that = this
      MilkRequestUtil.saveArea(this.formData, function (response) {
        if (response.id) {
          that.updateAreaList()
          that.showEditDialog = false
        }
      })
    },
    remove (id) {
      let that = this
      MilkRequestUtil.removeArea(id, () => { that.updateAreaList() })
    },
    onFilterChange (item) {
      this.queryParam.page = 1
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateAreaList()
    },
    updateAreaList () {
      let that = this
      this.pageData = {}
      MilkRequestUtil.queryAreaList({queryParam: this.queryParam}, function (response) {
        if (response) {
          that.pageData = response
        }
      })
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateAreaList()
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/milk/area/MilkAreaListPage.vue